import React, { useState } from 'react';

import { Autocomplete, TextField } from '@mui/material';

import { useGetBusinesses } from '~/hooks/apis/business-traveller/useBusinessList';

const BUSINESS_SEARCH_PAGE_SIZE = 20;

interface Props {
  value: App.Business | null;
  onChange: (business: App.Business | null) => void;
  disabled?: boolean;
}

export default function BusinessSelect({ value, onChange, disabled }: Props) {
  const [search, setSearch] = useState('');
  const { data, isFetching } = useGetBusinesses({
    status: 'active',
    page: 0,
    pageSize: BUSINESS_SEARCH_PAGE_SIZE,
    nameString: search.trim() || undefined,
  });

  return (
    <Autocomplete
      size="small"
      options={data?.result ?? []}
      value={value}
      onChange={(_event, business) => onChange(business)}
      inputValue={search}
      onInputChange={(_event, text) => setSearch(text)}
      getOptionLabel={(business) => business.name}
      isOptionEqualToValue={(option, selected) => option.id === selected.id}
      filterOptions={(options) => options}
      loading={isFetching}
      disabled={disabled}
      renderInput={(params) => <TextField {...params} label="Business" />}
    />
  );
}
